const localization = {
  ua: {
    selectLocalization: 'Оберiть мову додатку',
    tools: {
      calibration: {
        title: 'Калібрування палива',
        description:
          'Інструмент для калібрування палива, запитує користувача номер ємності та тип палива, висоту палива у вибраній ємності в сантиметрах. При натисканні кнопки "Розрахувати" проводяться розрахунки згідно з калібрувальною таблицею, результат округляється до цілих чисел і виводиться в літрах. Є можливість виключити трубопровід із розрахунку об`єму. Також після вибору ємності з`являється кнопка "Інформація про резервуар", при натисканні на яку відкривається модальне вікно з детальною інформацією про резервуар (Максимальний об`єм, мертвий залишок і т.д.)',
        inputLabel_1: 'Введіть висоту палива з метрштоку в см',
        inputLabel_2: 'Враховувати трубопровід у розрахунках?',
        inputPlaceholder_1: 'Натисніть, щоб ввести сантиметри',
        button_1: 'Розрахувати!',
        button_2: 'Інформація про резервуар',
        resultText_1: 'Увага! Об`єм палива нижче мертвого залишку: ',
        resultText_2: 'Помилка! Некоректні дані!',
        resultText_3: 'Об`єм палива: ',
      },
      densityCalc: {
        title: 'Калькулятор щільності',
        description:
          'Інструмент для обчислення об`єму/маси/щільності палива. Запитує у користувача величину, що обчислюється, після вибору величини запитує об`єм/щільність/масу, в залежності від вибору обчислюваної величини. При натисканні на кнопку "Розрахувати" проводяться розрахунки, результат виводиться з округленням до двох знаків після коми, за винятком щiльностi - до чотирьох знаків після коми.',
        units: {
          inputSelect: {
            volume: 'Об`єм',
            weight: 'Маса',
            density: 'Щiльнiсть',
          },
          inputLabel: {
            volume: 'об`єм',
            weight: 'масу',
            density: 'щiльнiсть',
          },
        },
        inputLabel_1: 'Обчислювана величина:',
        inputLabel_2: 'Заповніть відомі дані:',
        inputLabel_3_1: 'Введіть ',
        inputLabel_3_2: ' палива:',
        result_1: 'При ',
        result_2: ' та ',
        inputSelect_1: 'Натисніть, для вибору',
        button_1: 'Розрахувати!',
      },
      expirationDate: {
        title: 'Підрахунок термінів придатності',
        description:
          'Інструмент для підрахунку термінів придатності товарів, запитує дату виготовлення, термін придатності та одиницю виміру терміну придатності (днів, місяців чи років). При натисканні на кнопку "Розрахувати" проводиться розрахунок. Якщо товар ще не прострочений - результатом буде дата, до якої товар придатний і який термін залишився до кінця терміну придатності. У протилежному випадку - результатом буде попередження, що товар прострочений, коли був прострочений, і скільки часу минуло з закiнчення терміну придатності.',
        inputLabel_1: 'Введiть дату виготовлення товару',
        inputLabel_2: 'Введiть термiн придатностi товару',
        inputPlaceholder_2: 'Натиснiть для введення',
        inputSelect1_2: 'Днiв',
        inputSelect2_2: 'Мiсяцiв',
        inputSelect3_2: 'Рокiв',
        button_1: 'Розрахувати!',
        resultText_1: 'Помилка! Некоректні дані!',
        resultText_2: 'Товар був прострочений',
        resultText_3: 'Термін придатності сплив ',
        resultText_4: 'Термін придатності сплине ',
        resultText_5: 'Товар придатний до:',
      },
      phoneBook: {
        title: 'Книга контактів та адрес',
        description:
          'Довідник, з номерами АЗС, назвами підприємств, районами, поштовими індексами, адресами та мінікартою. При натисканні на вибір АЗС з`явиться випадаючий список з усіма доступними АЗС, з якого можна вибрати потрібну АЗС. Також є можливість зробити пошук за назвою/адресою/номером, для перемикання способу пошуку потрібно натиснути на кнопку із зображенням лупи, після чого почати вводити відому інформацію. Після початку введення відобразиться список АЗС, інформація яких збігається з введеними даними, після чого можна вибрати шукану АЗС. Перемикання способу пошуку назад до списку здійснюється натисканням кнопки із зображенням списку. Після вибору АЗС відобразиться детальна інформація (номер телефону, адреса тощо). При натисканні на номер телефону відкривається додаток для дзвінків з набраним номером обраної АЗС. При натисканні на міні-карту відкривається додаток "Google Maps", з встановленою точкою координат на обраній АЗС, якщо встановлено на пристрої, в іншому випадку відкривається веб-версія. Під картою знаходяться кнопка "Копіювати" - при натисканні копіює дані в буфер обміну, і кнопка "Поділитися" (Відображається не у всіх браузерах) - при натисканні пропонує користувачеві поділитися інформацією в доступних месенджерах.',
        sharingText: {
          btnCopy: 'Копіювати',
          btnShare: 'Поділитися',
          address: 'адреса',
          gmaps: 'Карти',
          linkToApp: 'Відправлено із додатку GS-Tools',
        },
        inputPlaceholder_1: 'Натиснiть, щоб почати введення',
      },
      reCalibrate: {
        title: 'Зворотне калібрування палива',
        description:
          'Інструмент для зворотного калібрування палива, запитує користувача номер ємності або тип палива, обсяг палива в літрах. При натисканні кнопки "Розрахувати" проводяться розрахунки згідно з калібрувальною таблицею, результат округляється до одного знака після коми і виводиться в сантиметрах. Є можливість виключити трубопровід із розрахунку об`єму. Також після вибору ємності з`являється кнопка "Інформація про резервуар", при натисканні на яку відкривається модальне вікно з детальною інформацією про резервуар (Максимальний об`єм, мертвий залишок і т.д.)',
        inputLabel_1: 'Введіть об`єм палива в л',
        inputLabel_2: 'Значення включає трубопровід?',
        inputPlaceholder_1: 'Натисніть, щоб ввести літри',
        button_1: 'Розрахувати!',
        button_2: 'Інформація про резервуар',
        resultText_1: 'Помилка! Значення менше допустимого!',
        resultText_2: 'Помилка! Введені некоректні дані!',
        resultText_3: 'Увага! Об`єм палива менше мертвого залишку: ',
        resultText_4: 'Висота наповнення: ',
      },
      salaryCalc: {
        title: 'Калькулятор зарплати',
        description:
          'Інструмент для підрахунку заробітної плати, запитує відпрацьованi години та продані літри. Є можливість змінити погодинну ставку та оплату за літраж. При натисканні на кнопку "Розрахувати" проводиться розрахунок. Підсумкова сума заокруглюється до коми (до цілих грн)',
        inputLabel_1:
          'Введіть кількість відпрацьованих годин та вартiсть однієї години (за замовчуванням 40.90 грн)',
        inputLabel_2:
          'Введіть кількість проданих літрів та вартiсть одного літра (за замовчуванням: 0,12 грн)',
        inputPlaceholder_1: 'Натиснiть для введення годин',
        inputPlaceholder_2: 'Натиснiть для введення лiтрiв',
        button_1: 'Розрахувати!',
        resultText_1: 'Виникла помилка! Введено некоректні дані!',
        resultText_2: 'Ваша зарплата',
        hours: 'год.',
      },
      reportGenerator: {
        title: 'Генератор звіту по товарам',
        description:
          'Інструмент для формування звіту по товарах. Запитує у користувача номер АЗС, кількість паливних чеків та HTM-файл звіту з програми «Бек-офіс». Якщо паливні чеки на зміні відсутні, у поле вводу потрібно ввести 0. Після отримання всіх даних від користувача з`являється кнопка «Згенерувати звіт», після натискання якої відкривається модальне вікно з попереднім переглядом звіту. У вікні доступні кнопки «Копіювати» — звіт копіюється до буфера обміну, та «Поділитися» — звіт копіюється до буфера обміну, відкривається веб-версія месенджера WhatsApp. Інструмент зберігає дані про попередні звіти на стороні клієнта (у локальному сховищі браузера). Для відображення різниці у продажах необхідно сформувати звіти за останні 8 діб (це виконується один раз). Якщо у звіті не відображається різниця у продажах — це означає, що звіт тижневої давнини відсутній.',
        labelFuel: 'Введіть кількість паливних чеків',
        labelCashOut: 'Введіть кількість готівки, виданної клієнтам',
        labelReport: 'Оберіть HTM файл звіту',
        inputPlaceholder: 'Натисніть для вводу',
        modalHeader: 'Ваш звіт готовий:',
        savedModalHeader: 'Збережений звіт',
        monthlyTrigger: 'Місячний звіт',
        savedReports: 'Перегляд збережених звітів',
        buttonGenerate: 'Сгенерувати звіт',
        buttonCopy: 'Копіювати',
        buttonShare: 'Відправити',
        reportNotFinded: 'Увага! Не знайдений збережений звіт за ',

        guideFuelChecks: {
          p1: 'Щоб дізнатися кількість паливних чеків, відкрийте програму "Бек-офіс" і на панелі інструментів виберіть розділ "Звіти з продажу ПММ" (1). Потім перейдіть до підрозділу "Підсумок з цінами" (2).',
          p2: 'Виберіть необхідну зміну, натиснувши кнопку "Вибрати зміну або період".',
          p3: 'Якщо у вибрану зміну відбулося обнулення, виберіть усі зміни за потрібну дату (1), а потім натисніть кнопку "Вибрати" (2).',
          p4: 'Кількість паливних чеків відобразиться в останній колонці внизу таблиці.',
        },
        guideReportExport: {
          p1: 'Щоб створити звіт по товарах, відкрийте програму "Бек-офіс" і на панелі інструментів виберіть розділ "Звіти з продажу товарів" (1). Потім перейдіть до підрозділу "Підсумковий" (2).',
          p2: 'Виберіть необхідну зміну, натиснувши кнопку "Вибрати зміну або період".',
          p3: 'Якщо у вибрану зміну відбулося обнулення, виберіть усі зміни за потрібну дату (1), а потім натисніть кнопку "Вибрати" (2).',
          p4: 'Натисніть на кнопку друку.',
          p5: 'Виберіть "Зберегти у файл" (1) і натисніть "Далі" (2).',
          p6: 'Виберіть формат файлу "HTML" (1) і натисніть на кнопку "..." (2) для вказання шляху збереження та назви файлу.',
          p7: 'Перейдіть до папки для звітів (рекомендується використовувати одну й ту саму папку для всіх звітів) і вкажіть ім’я файлу (1). Рекомендується використовувати дату як ім’я файлу для зручного пошуку. Потім натисніть "Зберегти" (2) і "Далі".',
          p8: 'Натисніть "Виберіть файл".',
          p9: 'Перейдіть до папки, у якій ви зберегли файл звіту, виберіть його (1) і натисніть "Відкрити" (2).',
        },
        guideHeader: 'Інструкція',
        errors: {
          errorHeader: 'Сталася помилка!',
          incorrectReport:
            'Некоректний файл звіту. Перевірте, що ви вибрали саме звіт по товарах та підрозділ "Підсумковий". Для довідки натисніть —',
          incorrectFileType:
            'Некоректний тип файлу. Перевірте, що ви вибрали тип файлу "HTML". Для довідки натисніть —',
        },
      },
      coffeeGuide: {
        title: 'Довідник кавових напоїв',
        description: 'werwerwer',
      },
    },
    menu: {
      burger: {
        title: 'Меню',
        mainPage: 'Головна сторiнка',
        contacts: 'Контакти',
        settings: 'Налаштування',
        about: 'Про додаток',
      },
      settings: {
        title: 'Налаштування додатку',
        selectLabel_1: 'Оберiть мову додатку:',
        select_1: 'Натиснiть для вибору мови',
        button_1: 'Застосувати',
        button_reset: 'Скидання всіх налаштувань',
      },
      contacts: {
        title: 'Контакти',
        text: 'Всі питання та пропозиції щодо програми GS-Tools, повідомлення про помилки та баги ви можете надсилати на електронну пошту розробника, або в офіційних спільнотах програми в месенджерах Telegram та Viber. Буду радий зворотному зв`язку!',
        email: 'Email - Написати листа розробнику',
        telegram: 'Telegram - Підписатися на канал',
        viber: 'Viber - Підписатися на канал',
      },
      about: {
        title: 'Про додаток',
        text: 'GS-Tools розроблено для вирішення повсякденних завдань працівників АЗС. На даний момент у додатку є такі утиліти:',
      },
    },
    selectorGS: {
      label_1: 'Виберiть АЗС:',
      select_1: 'Натисніть, щоб вибрати АЗС',
    },
    selectorGasType: {
      label_1: 'Виберiть тип палива:',
      select_1: 'Натисніть, щоб вибрати паливо',
    },
    tankInfo: {
      header_1: 'Інформація про резервуар',
      header_2: 'Резервуар №',
      text_1: 'Тип палива: ',
      text_2: 'Трубопровід: ',
      text_3: 'Мертвий залишок: ',
      text_4: 'Максимальний об`єм: ',
      text_5: 'Максимальна висота: ',
    },
  },
  ru: {
    selectLocalization: 'Выберите язык приложения',
    tools: {
      calibration: {
        title: 'Калибровка топлива',
        description:
          'Инструмент для калибровки топлива, запрашивает у пользователя номер ёмкости или вид топлива, высоту топлива в выбранной ёмкости в сантиметрах. При нажатии кнопки "Рассчитать" производятся расчёты согласно калибровочной таблицы, результат округляется до целых чисел и выводится в литрах. Есть возможность исключить трубопровод из расчёта объёма. Так-же после выбора ёмкости появляется кнопка "Информация о резервуаре", при нажатии на которую открывается модальное окно с подробной информацией о резервуаре (Максимальный объём, мёртвый остаток и т.д.)',
        inputLabel_1: 'Введите высоту топлива с метрштока в см',
        inputLabel_2: 'Учитывать трубопровод в рассчётах?',
        inputPlaceholder_1: 'Нажмите для ввода сантиметров',
        button_1: 'Рассчитать!',
        button_2: 'Информация о резервуаре',
        resultText_1: 'Внимание! Объём топлива ниже мёртвого остатка: ',
        resultText_2: 'Ошибка! Некорректные данные!',

        resultText_3: 'Объём топлива: ',
      },
      densityCalc: {
        title: 'Калькулятор плотности',
        description:
          'Инструмент для вычисления объёма/массы/плотности топлива. Запрашивает у пользователя вычисляемую величину, после выбора величины запрашивает объём/плотность/массу, в зависимости от выбора вычисляемой величины. При нажатии на кнопку "Рассчитать" производятся расчёты, результат выводится с округлением до двух знаков после запятой, за исключением плотности - до четырёх знаков после запятой.',
        units: {
          inputSelect: {
            volume: 'Объём',
            weight: 'Масса',
            density: 'Плотность',
          },
          inputLabel: {
            volume: 'объём',
            weight: 'массу',
            density: 'плотность',
          },
        },
        inputLabel_1: 'Вычисляемая величина:',
        inputLabel_2: 'Заполните известные данные:',
        inputLabel_3_1: 'Введите ',
        inputLabel_3_2: ' топлива:',
        result_1: 'При ',
        result_2: ' и ',
        inputSelect_1: 'Нажмите для выбора',
        button_1: 'Рассчитать!',
      },
      expirationDate: {
        title: 'Подсчёт сроков годности',
        description:
          'Инструмент для подсчёта сроков годности товаров, запрашивает дату изготовления, срок годности и единицу измерения срока годности (дней, месяцев или лет). При нажатии на кнопку "Рассчитать" производится расчёт. В случае, если товар еще не просрочен - результатом будет дата, до которой товар годен и какой срок остался до конца срока годности. В обратном случае - результатом будет предупреждение, что товар просрочен, когда был просрочен, и сколько времени прошло с выхода срока годности.',
        inputLabel_1: 'Введите дату изготовления товара',
        inputLabel_2: 'Введите срок годности товара',
        inputPlaceholder_2: 'Нажмите для ввода',
        inputSelect1_2: 'Дней',
        inputSelect2_2: 'Месяцев',
        inputSelect3_2: 'Лет',
        button_1: 'Рассчитать!',
        resultText_1: 'Ошибка! Некорректные данные!',
        resultText_2: 'Товар был просрочен',
        resultText_3: 'Срок годности истёк ',
        resultText_4: 'Срок годности истекает ',
        resultText_5: 'Товар годен до:',
      },
      phoneBook: {
        title: 'Книга контактов и адресов',
        description:
          'Справочник, с номерами АЗС, названиями предприятий, районами, почтовыми индексами, адресами и миникартой. При нажатии на выбор АЗС отобразится выпадающий список со всеми доступными АЗС из которого можно выбрать искомую АЗС. Так-же есть возможность сделать поиск по названию/адресу/номеру, для переключения способа поиска нужно нажать на кнопку с изображением лупы, после чего начать вводить известную информацию. После начала ввода отобразится список АЗС, информация которых совпадает с введёнными данными, после чего можно выбрать искомую АЗС. Переключение способа поиска назад к списку осуществляется нажатием кнопки с изображением списка. После выбора АЗС отобразится подробная информация (номер телефона, адрес и т.д.). При нажатии на номер телефона открывается приложение для звонков с набранным номером выбранной АЗС. При нажатии на мини-карту открывается приложение "Google Maps", с установленой точкой координат на выбранной АЗС, если установлено на устройстве, в противном случае открывается веб версия. Под картой находятся кнопка "Копировать" - при нажатии копирует данные в буфер обмена, и кнопка "Поделиться" (Отображается не во всех браузерах) - при нажатии предлагает пользователю поделиться информацией в доступных мессенджерах.',
        sharingText: {
          btnCopy: 'Копировать',
          btnShare: 'Поделиться',
          address: 'адрес',
          gmaps: 'Карты',
          linkToApp: 'Отправлено из приложения GS-Tools',
        },
        inputPlaceholder_1: 'Нажмите, чтобы начать ввод',
      },
      reCalibrate: {
        title: 'Обратная калибровка топлива',
        description:
          'Инструмент для обратной калибровки топлива, запрашивает у пользователя номер ёмкости или вид топлива, объём топлива в литрах. При нажатии кнопки "Рассчитать" производятся расчёты согласно калибровочной таблицы, результат округляется до одного знака после запятой и выводится в сантиметрах. Есть возможность исключить трубопровод из расчёта объёма. Так-же после выбора ёмкости появляется кнопка "Информация о резервуаре", при нажатии на которую открывается модальное окно с подробной информацией о резервуаре (Максимальный объём, мёртвый остаток и т.д.)',
        inputLabel_1: 'Введите объём топлива в л',
        inputLabel_2: 'Значение включает в себя трубопровод?',
        inputPlaceholder_1: 'Нажмите для ввода литров',
        button_1: 'Рассчитать!',
        button_2: 'Информация о резервуаре',
        resultText_1: 'Ошибка! Значение меньше допустимого!',
        resultText_2: 'Ошибка! Введены некорректные данные!',
        resultText_3: 'Внимание! Объём топлива ниже мёртвого остатка: ',
        resultText_4: 'Высота напролнения: ',
      },
      salaryCalc: {
        title: 'Калькулятор зарплаты',
        description:
          'Инструмент для подсчёта заработной платы, запрашивает отработанные часы и проданные литры. Есть возможность изменить почасовую ставку и оплату за литраж. При нажатии на кнопку "Рассчитать" производится расчёт. Итоговая сумма округляется до запятой (до целых грн)',
        inputLabel_1:
          'Введите количество отработанных часов и цену одного часа (по умолчанию 40.90 грн)',
        inputLabel_2:
          'Введите колличество проданных литров и цену одного литра (по умолчанию: 0,12 грн)',
        inputPlaceholder_1: 'Нажмите для ввода часов',
        inputPlaceholder_2: 'Нажмите для ввода литров',
        button_1: 'Рассчитать!',
        resultText_1: 'Произошла ошибка! Ввдены некорректные данные!',
        resultText_2: 'Ваша зарплата',
        hours: 'ч.',
      },
      reportGenerator: {
        title: 'Генератор отчёта по товарам',
        description:
          'Инструмент для формирования отчёта по товарам. Запрашивает у пользователя номер АЗС, количество топливных чеков и HTM-файл отчёта из программы «Бэк-офис». Если топливные чеки на смене отсутствуют, в поле ввода нужно ввести 0. После получения всех данных от пользователя появляется кнопка «Сгенерировать отчёт», при нажатии на которую открывается модальное окно с предпросмотром отчёта. В окне доступны кнопки «Копировать» — отчёт копируется в буфер обмена, и «Поделиться» — отчёт копируется в буфер обмена, открывается веб-версия мессенджера WhatsApp. Инструмент сохраняет данные о предыдущих отчётах на стороне клиента (в локальном хранилище браузера). Для отображения разницы продаж необходимо сформировать отчёты за последние 8 суток (это делается один раз). Если в отчёте не отображается разница продаж — это означает, что отчёт недельной давности отсутствует. ',
        labelFuel: 'Введите количество топливных чеков',
        labelCashOut: 'Введите количество наличных, виданных клиентам',
        labelReport: 'Выберите HTM файл отчёта',
        inputPlaceholder: 'Нажмите для ввода',
        modalHeader: 'Ваш отчёт готов:',
        savedModalHeader: 'Сохранённый отчёт',
        monthlyTrigger: 'Месячный отчёт',
        savedReports: 'Просмотр сохранённых отчётов',
        buttonGenerate: 'Сгенерировать отчёт',
        buttonCopy: 'Копировать',
        buttonShare: 'Отправить',
        guideHeader: 'Инструкция',
        reportNotFinded: 'Внимание! Не найден сохранённый отчёт за ',
        errors: {
          errorHeader: 'Произошла ошибка!',
          incorrectReport:
            'Некорректный файл отчёта. Проверьте, что вы выбрали именно отчёт по товарам и подраздел "Підсумковий". Для справки нажмите —',
          incorrectFileType:
            'Некорректный тип файла. Проверьте, что вы выбрали тип файла "HTML". Для справки нажмите —',
        },

        guideFuelChecks: {
          p1: 'Чтобы узнать количество топливных чеков, откройте программу "Бэк-офис" и на панели инструментов выберите раздел "Звіти з продажу ПММ" (1). Затем перейдите в подраздел "Підсумок з цінами" (2).',
          p2: 'Выберите нужную смену, нажав на кнопку "Вибрати зміну або період".',
          p3: 'Если в выбранную смену происходило обнуление, выберите все смены за нужную дату (1), а затем нажмите кнопку "Вибрати" (2).',
          p4: 'Количество топливных чеков отобразится в последней колонке в самом низу таблицы.',
        },

        guideReportExport: {
          p1: 'Чтобы создать отчёт по товарам, откройте программу "Бэк-офис" и на панели инструментов выберите раздел "Звіти з продажу товарів" (1). Затем перейдите в подраздел "Підсумковий" (2).',
          p2: 'Выберите нужную смену, нажав на кнопку "Вибрати зміну або період".',
          p3: 'Если в выбранную смену происходило обнуление, выберите все смены за нужную дату (1), а затем нажмите кнопку "Вибрати" (2).',
          p4: 'Нажмите на кнопку печати.',
          p5: 'Выберите "Зберегти у файл" (1) и нажмите "Далі" (2).',
          p6: 'Выберите формат файла "HTML" (1) и нажмите на кнопку "..." (2) для указания пути сохранения и названия файла.',
          p7: 'Перейдите в папку для отчетов (рекомендуется использовать одну и ту же папку для всех отчетов) и укажите имя файла (1). Рекомендуется использовать дату в качестве имени файла для удобного поиска. Затем нажмите "Сохранить" (2) и "Далі".',
          p8: 'Нажмите "Выберите файл"',
          p9: 'Зайдите в папку, в которую вы сохранили файл отчёта, выберите его (1) и нажмите "Открыть" (2).',
        },
      },
      coffeeGuide: {
        title: 'Справочник кофейных напитков',
        description: 'werwerwer',
      },
    },
    menu: {
      burger: {
        title: 'Меню',
        mainPage: 'Главная страница',
        settings: 'Настройки',
        contacts: 'Контакты',
        about: 'О приложении',
      },
      settings: {
        title: 'Настройки приложения',
        selectLabel_1: 'Выберите язык приложеня:',
        select_1: 'Нажмите для выбора языка',
        button_1: 'Применить',
        button_reset: 'Сброс всех настроек',
      },
      contacts: {
        title: 'Контакты',
        text: 'Все вопросы и предложения, касающиеся приложения GS-Tools, сообщения об ошибках и багах вы можете отправлять на электронную почту разработчика, или в официальных сообществах приложения в мессенджерах Telegram и Viber. Буду рад обратной связи!',
        email: 'Email - Написать письмо разработчику',
        telegram: 'Telegram - Подписаться на канал',
        viber: 'Viber - Подписаться на канал',
      },
      about: {
        title: 'О приложении',
        text: 'Приложение GS-Tools разработано для решения повседневных задач работников АЗС. На данный момент в приложении имеются такие утилиты:',
      },
    },
    selectorGS: {
      label_1: 'Выберите АЗС:',
      select_1: 'Нажмите для выбора АЗС',
    },
    selectorGasType: {
      label_1: 'Выберите вид топлива:',
      select_1: 'Нажмите для выбора топлива',
    },
    tankInfo: {
      header_1: 'Информация о резервуаре',
      header_2: 'Резервуар №',
      text_1: 'Вид топлива: ',
      text_2: 'Трубопровод: ',
      text_3: 'Мёртвый остаток: ',
      text_4: 'Максимальный объём: ',
      text_5: 'Максимальная высота: ',
    },
  },
};

export default localization;
